<template>
  <div class="dashboard-ui">
    <b-row class="dashboard-section-row dashboard-section-row--metrics dashboard-metrics-row align-items-stretch">
      <b-col
        cols="12"
        sm="6"
        class="mb-1 dashboard-metric-col"
      >
        <b-card
          no-body
          class="metric-card"
        >
          <b-card-body>
            <div class="metric-content">
              <div>
                <small class="metric-title">Total Ads</small>
                <h2 class="metric-value">
                  {{ summaryCards.totalAds }}
                </h2>
              </div>
              <img
                src="/svg/home/Chart.svg"
                alt="Total Ads"
                class="metric-icon"
              >
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        sm="6"
        class="mb-1 dashboard-metric-col"
      >
        <b-card
          no-body
          class="metric-card"
        >
          <b-card-body>
            <div class="metric-content">
              <div>
                <small class="metric-title">Followers</small>
                <h2 class="metric-value">
                  {{ summaryCards.followers }}
                </h2>
              </div>
              <img
                src="/svg/home/Followers.svg"
                alt="Followers"
                class="metric-icon"
              >
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        sm="6"
        class="mb-1 dashboard-metric-col"
      >
        <b-card
          no-body
          class="metric-card"
        >
          <b-card-body>
            <div class="metric-content">
              <div>
                <small class="metric-title">Total Clicks</small>
                <h2 class="metric-value">
                  {{ summaryCards.totalClicks }}
                </h2>
              </div>
              <img
                src="/svg/home/Clicks.svg"
                alt="Total Clicks"
                class="metric-icon"
              >
            </div>
          </b-card-body>
        </b-card>
      </b-col>
      <b-col
        cols="12"
        sm="6"
        class="mb-1 create-ad-col"
      >
        <div
          class="create-ad-tile"
          role="button"
          tabindex="0"
          @click="openCreateAdModal"
          @keydown.enter.prevent="openCreateAdModal"
        >
          <b-card
            no-body
            class="metric-card create-ad-card"
          >
            <b-card-body class="text-center d-flex align-items-center justify-content-center">
              <div>
                <div class="create-ad-plus">
                  <img
                    src="/svg/home/Ads.svg"
                    alt="Create Ad"
                    class="create-ad-icon"
                  >
                </div>
                <div class="create-ad-text">
                  Create Ad
                </div>
              </div>
            </b-card-body>
          </b-card>
        </div>
      </b-col>
    </b-row>

    <b-row class="dashboard-section-row dashboard-section-row--chart">
      <b-col cols="12">
        <apex-line-area-chart />
      </b-col>
    </b-row>

    <b-row>
      <b-col
        lg="7"
        class="mb-2"
      >
        <b-card
          no-body
          class="followers-card h-100"
        >
          <b-card-header class="bg-white border-0 followers-header">
            <h4 class="mb-0 section-title">
              Recent Followers
            </h4>
            <b-form-input
              v-model="searchTerm"
              placeholder="Search"
              class="followers-search"
            />
          </b-card-header>
          <b-card-body class="pt-0">
            <div v-if="isFollowersLoading" class="text-center py-2">
              <b-spinner small label="Loading followers..." />
            </div>
            <div v-else-if="followersError" class="text-danger py-1 px-1">
              {{ followersError }}
            </div>
            <div v-else-if="!filteredFollowers.length" class="text-muted py-2 px-1">
              No recent followers.
            </div>
            <template v-else>
            <div class="followers-table-head">
              <span class="head-checkbox">
                <input
                  v-model="selectAllFollowers"
                  type="checkbox"
                  class="follower-checkbox"
                  @change="toggleAllFollowers"
                >
              </span>
              <span class="head-name">Name</span>
              <span class="head-date">Date</span>
            </div>
            <div
              v-for="(item, idx) in filteredFollowers"
              :key="`follower-${idx}-${item.name}`"
              class="follower-row"
            >
              <div class="row-left">
                <input
                  v-model="item.selected"
                  type="checkbox"
                  class="follower-checkbox"
                  @change="syncSelectAllFollowers"
                >
                <b-avatar
                  :src="item.avatar"
                  size="34"
                  class="mr-1"
                />
                <div>
                  <div class="follower-name">
                    {{ item.name }}
                  </div>
                  <small class="follower-subtext">{{ item.subtext }}</small>
                </div>
              </div>
              <div class="follower-date">
                {{ item.date }}
              </div>
            </div>
            <div class="followers-footer">
              <small>Showing {{ filteredFollowers.length }} follower{{ filteredFollowers.length === 1 ? '' : 's' }}</small>
            </div>
            </template>
          </b-card-body>
        </b-card>
      </b-col>

      <b-col
        lg="5"
        class="mb-2"
      >
        <b-card
          no-body
          class="running-ads-card h-100"
        >
          <b-card-header class="bg-white border-0 running-ads-header">
            <h4 class="mb-0 section-title">
              Best Running Ads
            </h4>
          </b-card-header>
          <b-card-body class="running-ads-body">
            <div class="best-ad-top">
              <div class="ad-stack">
                <div class="stack-card stack-3" />
                <div class="stack-card stack-2" />
                <div class="stack-card stack-1">
                  <div class="ad-preview-image">
                    <img
                      v-if="bestRunningAdImage"
                      :src="bestRunningAdImage"
                      alt="Best running ad"
                      class="ad-preview-media"
                    >
                    <template v-else>
                      <span class="ad-preview-lens" />
                      <span class="ad-preview-title">No Preview</span>
                    </template>
                  </div>
                </div>
              </div>
              <div class="ad-details">
                <h5 class="ad-detail-name">
                  {{ bestRunningAdName }}
                </h5>
                <p class="ad-detail-time">
                  {{ bestRunningAdCreatedAt }}
                </p>
                <p class="ad-copy">
                  {{ bestRunningAdDescription }}
                </p>
                <div class="ad-arrows">
                  <feather-icon
                    icon="ArrowLeftIcon"
                    size="20"
                    class="ad-arrow-icon"
                  />
                  <feather-icon
                    icon="ArrowRightIcon"
                    size="20"
                    class="ad-arrow-icon"
                  />
                </div>
              </div>
            </div>
            <div class="ad-metrics-grid">
              <div
                v-for="(metric, idx) in bestAdMetrics"
                :key="idx"
                class="ad-metric-card"
              >
                <div class="ad-metric-text">
                  <span class="ad-metric-value">{{ metric.value }}</span>
                  <span class="ad-metric-label">{{ metric.label }}</span>
                </div>
                <img
                  :src="metric.icon"
                  :alt="metric.label"
                  class="ad-metric-icon"
                >
              </div>
            </div>
          </b-card-body>
        </b-card>
      </b-col>
    </b-row>

    <b-modal
      v-model="showCreateAdModal"
      hide-header
      hide-footer
      centered
      size="xl"
      modal-class="create-ad-modal"
    >
      <div class="modal-top">
        <button
          type="button"
          class="modal-close-btn"
          @click="showCreateAdModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
        <h2>Create New Ad</h2>
        <p>Please provide more details about your Ads.</p>
      </div>

      <div class="modal-body-wrap">
        <h3 class="section-heading">
          1. Basic Information
        </h3>

        <label class="field-label">Title*</label>
        <b-form-input
          v-model="adForm.title"
          class="modal-field"
          :class="{ 'is-invalid': fieldErrors.title }"
          placeholder="Enter Title"
        />
        <p
          v-if="fieldErrors.title"
          class="field-error"
        >
          {{ fieldErrors.title }}
        </p>

        <label class="field-label">Description*</label>
        <b-form-input
          v-model="adForm.description"
          class="modal-field"
          :class="{ 'is-invalid': fieldErrors.description }"
          placeholder="Enter Description"
        />
        <p
          v-if="fieldErrors.description"
          class="field-error"
        >
          {{ fieldErrors.description }}
        </p>

        <div>
          <label class="field-label">Select Ad Type</label>
          <b-form-select
            v-model="adForm.adType"
            :options="adTypeOptions"
            class="modal-field"
          />
        </div>

        <h3 class="section-heading">
          2. Media Upload
        </h3>
        <ad-media-drop-zone
          v-model="adForm.mediaFiles"
          :ad-type="adForm.adType"
          @format-error="onMediaFormatError"
        />
        <p
          v-if="fieldErrors.media"
          class="field-error"
        >
          {{ fieldErrors.media }}
        </p>

        <h3 class="section-heading">
          3. Call Actions
        </h3>
        <div class="call-action-row">
          <label>CTA Button Text</label>
          <div>
            <b-form-input
              v-model="adForm.ctaText"
              class="modal-field"
              :class="{ 'is-invalid': fieldErrors.ctaText }"
              placeholder="Enter CTA Button Text"
            />
            <p
              v-if="fieldErrors.ctaText"
              class="field-error"
            >
              {{ fieldErrors.ctaText }}
            </p>
          </div>
        </div>
        <div class="call-action-row">
          <label>Destination URL</label>
          <div>
            <b-form-input
              v-model="adForm.destinationUrl"
              class="modal-field"
              :class="{ 'is-invalid': fieldErrors.destinationUrl }"
              placeholder="Enter Destination URL"
              @blur="onDestinationUrlBlur"
            />
            <p
              v-if="fieldErrors.destinationUrl"
              class="field-error"
            >
              {{ fieldErrors.destinationUrl }}
            </p>
          </div>
        </div>

        <div class="submit-wrap">
          <b-button
            class="submit-btn"
            @click="openScheduleModal"
          >
            Schedule Ad
          </b-button>
        </div>
      </div>
    </b-modal>

    <b-modal
      v-model="showScheduleModal"
      hide-header
      hide-footer
      centered
      size="xl"
      no-close-on-backdrop
      modal-class="schedule-date-modal"
    >
      <div class="modal-top">
        <button
          type="button"
          class="modal-close-btn"
          @click="showScheduleModal = false"
        >
          <feather-icon
            icon="XIcon"
            size="18"
          />
        </button>
        <h2>Schedule Date</h2>
        <p>Select Your Ad Upload Date and Expire Date</p>
      </div>

      <div class="modal-body-wrap">
        <div class="schedule-highlight">
          {{ formattedStartTime }} || {{ formattedStartDate }} &nbsp;&nbsp;&nbsp;&nbsp; To {{ formattedEndTime }} || {{ formattedEndDate }}
        </div>

        <div class="field-row mt-2">
          <div
            class="time-date-field has-icon native-picker-field"
            :class="{ 'is-invalid': scheduleFieldErrors.startTime }"
          >
            <label>Start Time</label>
            <b-form-input
              v-model="scheduleForm.startTime"
              type="time"
              placeholder="10:15 AM"
              :class="{ 'is-invalid': scheduleFieldErrors.startTime }"
            />
            <feather-icon
              icon="ClockIcon"
              size="18"
              class="field-icon"
            />
            <p
              v-if="scheduleFieldErrors.startTime"
              class="field-error"
            >
              {{ scheduleFieldErrors.startTime }}
            </p>
          </div>
          <div
            class="time-date-field has-icon native-picker-field"
            :class="{ 'is-invalid': scheduleFieldErrors.endTime }"
          >
            <label>End Time</label>
            <b-form-input
              v-model="scheduleForm.endTime"
              type="time"
              placeholder="10:15 AM"
              :class="{ 'is-invalid': scheduleFieldErrors.endTime }"
            />
            <feather-icon
              icon="ClockIcon"
              size="18"
              class="field-icon"
            />
            <p
              v-if="scheduleFieldErrors.endTime"
              class="field-error"
            >
              {{ scheduleFieldErrors.endTime }}
            </p>
          </div>
        </div>

        <div class="field-row mt-1">
          <div
            class="time-date-field has-icon native-picker-field"
            :class="{ 'is-invalid': scheduleFieldErrors.startDate }"
          >
            <label>Start Date</label>
            <b-form-input
              v-model="scheduleForm.startDate"
              type="date"
              placeholder="Jan 1, 2026"
              :class="{ 'is-invalid': scheduleFieldErrors.startDate }"
            />
            <feather-icon
              icon="CalendarIcon"
              size="18"
              class="field-icon"
            />
            <p
              v-if="scheduleFieldErrors.startDate"
              class="field-error"
            >
              {{ scheduleFieldErrors.startDate }}
            </p>
          </div>
          <div
            class="time-date-field has-icon native-picker-field"
            :class="{ 'is-invalid': scheduleFieldErrors.endDate || scheduleFieldErrors.scheduleRange }"
          >
            <label>End Date</label>
            <b-form-input
              v-model="scheduleForm.endDate"
              type="date"
              placeholder="Jan 7, 2026"
              :class="{ 'is-invalid': scheduleFieldErrors.endDate || scheduleFieldErrors.scheduleRange }"
            />
            <feather-icon
              icon="CalendarIcon"
              size="18"
              class="field-icon"
            />
            <p
              v-if="scheduleFieldErrors.endDate"
              class="field-error"
            >
              {{ scheduleFieldErrors.endDate }}
            </p>
            <p
              v-else-if="scheduleFieldErrors.scheduleRange"
              class="field-error"
            >
              {{ scheduleFieldErrors.scheduleRange }}
            </p>
          </div>
        </div>

        <div class="submit-wrap schedule-submit-wrap">
          <b-button
            class="submit-btn"
            :disabled="submittingCreateAd"
            @click="submitCreateAd"
          >
            {{ submittingCreateAd ? 'Submitting...' : 'Submit for Approval' }}
            <b-spinner
              v-if="submittingCreateAd"
              small
              class="ml-50"
              label="Submitting"
            />
          </b-button>
        </div>
      </div>
    </b-modal>

    <vendor-outcome-modal
      :visible.sync="showOutcomeModal"
      :variant="outcomeVariant"
      @primary="handleOutcomePrimary"
    />
  </div>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BCardHeader,
  BCardBody,
  BFormInput,
  BFormSelect,
  BAvatar,
  BModal,
  BSpinner,
} from 'bootstrap-vue'
import { vendorPanelApi } from '@/services/vendorPanelApi'
import { validateScheduleRange, validateDestinationUrl, extractApiErrorMessage, formatIsoDateLabel, buildClientRequestId, getAdMediaFormatError } from '@/utils/adCreate'
import AdMediaDropZone from '@/features/ads/components/AdMediaDropZone.vue'
import VendorOutcomeModal from '@/components/vendor/VendorOutcomeModal.vue'
import ApexLineAreaChart from '../components/DashboardGraph.vue'

const BEST_AD_METRIC_DEFAULTS = [
  { value: 0, label: 'Like', icon: '/svg/ads/like.svg' },
  { value: 0, label: 'Clicks', icon: '/svg/ads/Click.svg' },
  { value: 0, label: 'Saved', icon: '/svg/ads/saved.svg' },
  { value: 0, label: 'Dislike', icon: '/svg/ads/dislike.svg' },
  { value: 0, label: 'Report', icon: '/svg/ads/report.svg' },
  { value: 0, label: 'Share', icon: '/svg/ads/share.svg' },
]

function buildBestAdMetrics(stats = {}) {
  return [
    { value: stats.likes || 0, label: 'Like', icon: '/svg/ads/like.svg' },
    { value: stats.clicks || 0, label: 'Clicks', icon: '/svg/ads/Click.svg' },
    { value: stats.saved || 0, label: 'Saved', icon: '/svg/ads/saved.svg' },
    { value: stats.dislikes || 0, label: 'Dislike', icon: '/svg/ads/dislike.svg' },
    { value: stats.reports || 0, label: 'Report', icon: '/svg/ads/report.svg' },
    { value: stats.shares || 0, label: 'Share', icon: '/svg/ads/share.svg' },
  ]
}

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    BFormInput,
    BFormSelect,
    BAvatar,
    BModal,
    BSpinner,
    ApexLineAreaChart,
    AdMediaDropZone,
    VendorOutcomeModal,
  },
  data() {
    return {
      showCreateAdModal: false,
      showScheduleModal: false,
      showOutcomeModal: false,
      outcomeVariant: 'ad-submitted',
      adForm: {
        title: '',
        description: '',
        adType: 'Image',
        ctaText: '',
        destinationUrl: '',
        mediaFiles: [],
      },
      scheduleForm: {
        startTime: '',
        endTime: '',
        startDate: '',
        endDate: '',
      },
      adTypeOptions: ['Image', 'Video'],
      accessToken: localStorage.getItem('accessToken'),
      baseApi: process.env.VUE_APP_APIENDPOINT,
      searchTerm: '',
      isFollowersLoading: false,
      followersError: '',
      selectAllFollowers: false,
      followers: [],
      summaryCards: {
        totalAds: 0,
        followers: 0,
        totalClicks: 0,
      },
      bestRunningAd: null,
      bestAdMetrics: BEST_AD_METRIC_DEFAULTS.map(metric => ({ ...metric })),
      submittingCreateAd: false,
      showFormValidation: false,
      destinationUrlTouched: false,
      showScheduleValidation: false,
      mediaFormatError: '',
    }
  },
  computed: {
    filteredFollowers() {
      if (!this.searchTerm) return this.followers
      const term = this.searchTerm.toLowerCase()
      return this.followers.filter(item => item.name.toLowerCase().includes(term))
    },
    bestRunningAdName() {
      return (this.bestRunningAd && this.bestRunningAd.ad_name) || 'Ad Name'
    },
    bestRunningAdCreatedAt() {
      return formatIsoDateLabel((this.bestRunningAd && this.bestRunningAd.created_at) || '')
    },
    bestRunningAdDescription() {
      return (this.bestRunningAd && this.bestRunningAd.description) || ''
    },
    bestRunningAdImage() {
      return (this.bestRunningAd && this.bestRunningAd.image) || ''
    },
    formattedStartTime() {
      return this.formatTimeLabel(this.scheduleForm.startTime)
    },
    formattedEndTime() {
      return this.formatTimeLabel(this.scheduleForm.endTime)
    },
    formattedStartDate() {
      return this.formatDateLabel(this.scheduleForm.startDate)
    },
    formattedEndDate() {
      return this.formatDateLabel(this.scheduleForm.endDate)
    },
    fieldErrors() {
      const errors = this.showFormValidation ? this.buildCreateAdFieldErrors() : {}
      if (this.mediaFormatError) errors.media = this.mediaFormatError
      if (this.destinationUrlTouched && !errors.destinationUrl) {
        const destinationError = validateDestinationUrl(this.adForm.destinationUrl)
        if (destinationError) errors.destinationUrl = destinationError
      }
      return errors
    },
    hasFormErrors() {
      return Object.keys(this.fieldErrors).length > 0
    },
    scheduleFieldErrors() {
      if (!this.showScheduleValidation) return {}
      return this.buildScheduleFieldErrors()
    },
    hasScheduleErrors() {
      return Object.keys(this.scheduleFieldErrors).length > 0
    },
  },
  watch: {
    '$route.query.create': function routeQueryCreateWatcher() {
      this.openCreateFromRoute()
    },
  },
  mounted() {
    this.loadDashboardData()
    this.openCreateFromRoute()
  },
  methods: {
    openCreateFromRoute() {
      if (this.$route.query.create !== '1') return
      this.$router.replace({ name: 'create-ad' }).catch(() => {})
    },
    async loadDashboardData() {
      this.isFollowersLoading = true
      this.followersError = ''
      try {
        const [dashboardRes, followersRes, bestRes] = await Promise.all([
          vendorPanelApi.dashboard(),
          vendorPanelApi.recentFollowers({ page: 1, per_page: 8, search: '' }),
          vendorPanelApi.bestRunningAds(),
        ])

        const dashboardData = dashboardRes?.data?.data || dashboardRes?.data || {}
        this.summaryCards.totalAds = dashboardData.totalAds || 0
        this.summaryCards.followers = dashboardData.followers || 0
        this.summaryCards.totalClicks = dashboardData.totalClicks || 0

        const followerRows = followersRes?.data?.data?.followers || []
        this.followers = followerRows.map(item => ({
          name: item.name || '',
          subtext: item.join_date || '',
          date: item.follow_date || '',
          avatar: item.avatar || '',
          selected: false,
        }))
        this.bestRunningAd = bestRes?.data?.data || null
        const stats = this.bestRunningAd?.stats || {}
        this.bestAdMetrics = buildBestAdMetrics(stats)
      } catch (error) {
        this.followers = []
        this.bestRunningAd = null
        this.followersError = error.response?.data?.message || 'Unable to load dashboard data.'
      } finally {
        this.isFollowersLoading = false
      }
    },
    toggleAllFollowers() {
      this.filteredFollowers.forEach(item => {
        item.selected = this.selectAllFollowers
      })
    },
    syncSelectAllFollowers() {
      this.selectAllFollowers = this.filteredFollowers.length > 0
        && this.filteredFollowers.every(item => item.selected)
    },
    openCreateAdModal() {
      this.$router.push({ name: 'create-ad' }).catch(() => {})
    },
    onDestinationUrlBlur() {
      this.destinationUrlTouched = true
    },
    onMediaFormatError(message) {
      this.mediaFormatError = message || ''
    },
    openScheduleModal() {
      this.destinationUrlTouched = true
      this.showFormValidation = true
      if (this.hasFormErrors) return
      this.showScheduleValidation = false
      this.showCreateAdModal = false
      this.showScheduleModal = true
    },
    buildCreateAdFieldErrors() {
      const errors = {}
      if (!this.adForm.title.trim()) errors.title = 'Title is required'
      if (!this.adForm.description.trim()) errors.description = 'Description is required'
      const destinationError = validateDestinationUrl(this.adForm.destinationUrl)
      if (destinationError) errors.destinationUrl = destinationError
      if (!this.adForm.ctaText.trim()) errors.ctaText = 'CTA button text is required'
      const imageFormatError = getAdMediaFormatError(this.adForm.mediaFiles, this.adForm.adType)
      if (imageFormatError) {
        errors.media = imageFormatError
      } else if (!Array.isArray(this.adForm.mediaFiles) || !this.adForm.mediaFiles.length) {
        errors.media = 'Media Upload requires at least one file'
      }
      return errors
    },
    buildScheduleFieldErrors() {
      const errors = {}
      if (!this.scheduleForm.startTime) errors.startTime = 'Start time is required'
      if (!this.scheduleForm.endTime) errors.endTime = 'End time is required'
      if (!this.scheduleForm.startDate) errors.startDate = 'Start date is required'
      if (!this.scheduleForm.endDate) errors.endDate = 'End date is required'
      const rangeError = validateScheduleRange(this.scheduleForm)
      if (rangeError) errors.scheduleRange = rangeError
      return errors
    },
    formatTimeLabel(value) {
      if (!value) return '00 : 00'
      const [hours = '00', minutes = '00'] = value.split(':')
      return `${hours.padStart(2, '0')} : ${minutes.padStart(2, '0')}`
    },
    formatDateLabel(value) {
      return formatIsoDateLabel(value)
    },
    async submitCreateAd() {
      if (this.submittingCreateAd) return
      this.showScheduleValidation = true
      if (this.hasScheduleErrors) return

      this.submittingCreateAd = true
      const clientRequestId = buildClientRequestId()
      try {
        await vendorPanelApi.submitAdForm({
          mode: 'draft',
          form: this.adForm,
          schedule: this.scheduleForm,
          clientRequestId,
        })
        this.showScheduleModal = false
        this.outcomeVariant = 'ad-submitted'
        this.showOutcomeModal = true
      } catch (error) {
        this.$swal({
          title: 'Error',
          text: extractApiErrorMessage(error, 'Unable to create ad right now'),
          icon: 'error',
          timer: 2200,
          showConfirmButton: false,
        })
      } finally {
        this.submittingCreateAd = false
      }
    },
    handleOutcomePrimary(variant) {
      if (variant === 'ad-submitted' || variant === 'ad-approved' || variant === 'ad-rejected') {
        this.$router.push({ name: 'my-ads' }).catch(() => {})
      } else if (variant === 'plan-upgraded') {
        this.$router.push({ name: 'pages-pricing' }).catch(() => {})
      }
    },
  },
}
</script>

<style lang="scss">
@import "@core/scss/vue/libs/chart-apex.scss";
@import "@core/scss/vue/libs/vue-flatpicker.scss";

.dashboard-ui {
  padding: 0 1.25rem 1.5rem;

  @media (min-width: 768px) {
    padding: 0 1.5rem 1.75rem;
  }

  .dashboard-section-row {
    margin-bottom: 1.25rem;
    margin-top: 0;

    @media (min-width: 768px) {
      margin-bottom: 1.5rem;
    }

    &--chart {
      margin-bottom: 1.25rem;
    }
  }

  .metric-card {
    box-shadow: 0 2px 10px rgba(34, 41, 47, 0.08);
    border: 0;
    border-radius: 10px;
    min-height: 100px;
    height: 100%;

    .card-body {
      padding: 1rem 1.15rem;
      display: flex;
      align-items: center;
      min-height: 100px;
    }
  }

  .metric-content {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
  }

  .metric-icon {
    width: 44px;
    height: 44px;
    object-fit: contain;
    flex-shrink: 0;
    display: block;
  }

  .metric-title {
    color: #6e6b7b;
    font-weight: 600;
    font-size: 14px;
    line-height: 1.2;
    display: block;
  }

  .metric-value {
    margin-top: 0.4rem;
    font-weight: 500;
    color: #4B465C;
    font-size: 26px;
    line-height: 1;
    margin-bottom: 0;
  }

  .create-ad-card {
    background: #082748;
    color: #fff;
    border-radius: 10px;
    box-shadow: 0 4px 14px rgba(8, 39, 72, 0.22);
    min-height: 100px;
    height: 100%;

    .create-ad-plus {
      width: 50px;
      height: 50px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .create-ad-icon {
      width: 48px;
      height: 48px;
      object-fit: contain;
      display: block;
    }

    .create-ad-text {
      margin-top: 0.8rem;
      font-weight: 600;
      font-size: 16px;
      color: #fff;
      line-height: 1;
    }

    .card-body {
      min-height: 100px;
    }
  }

  .create-ad-tile {
    height: 100%;
    min-height: 100px;
    cursor: pointer;
    outline: none;
    border-radius: 10px;
  }

  .create-ad-tile:focus-visible {
    box-shadow: 0 0 0 2px #fff, 0 0 0 4px #082748;
  }

  .create-ad-col .create-ad-card {
    width: 100%;
  }

  .dashboard-metrics-row {
    @media (min-width: 992px) {
      flex-wrap: nowrap;
    }
  }

  .dashboard-metrics-row .dashboard-metric-col {
    @media (min-width: 992px) {
      flex: 1 1 0% !important;
      max-width: none !important;
      width: auto !important;
    }
  }

  .dashboard-metrics-row .create-ad-col {
    @media (min-width: 992px) {
      flex: 0 0 148px !important;
      max-width: 148px !important;
      width: 148px !important;
    }
  }

  .followers-card,
  .running-ads-card {
    box-shadow: 0 4px 18px rgba(34, 41, 47, 0.1);
    border-radius: 14px;
    border: 0;
  }

  .running-ads-header {
    padding: 1.75rem 2rem 1.25rem;
  }

  .running-ads-body {
    padding: 0 2rem 2.25rem;
  }

  .followers-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1rem 1rem 0.6rem;
  }

  .section-title {
    font-size: 1.1rem;
    font-weight: 700;
    color: #3f3b57;
  }

  .followers-search {
    width: 130px;
    height: 30px;
    border-color: #eceaf3;
    font-size: 12px;
  }

  .followers-table-head {
    display: flex;
    justify-content: space-between;
    color: #8a86a3;
    text-transform: uppercase;
    font-size: 11px;
    font-weight: 600;
    border-top: 1px solid #f1eff6;
    border-bottom: 1px solid #f1eff6;
    padding: 0.6rem 0.7rem;
  }

  .head-name {
    padding-left: 1.7rem;
  }

  .follower-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid #f1eff6;
    padding: 0.55rem 0.7rem;
  }

  .row-left {
    display: flex;
    align-items: center;
  }

  .follower-checkbox {
    margin-right: 0.8rem;
  }

  .follower-name {
    font-weight: 600;
    color: #4d4963;
    font-size: 0.95rem;
  }

  .follower-subtext {
    color: #9f9bb3;
    font-size: 0.75rem;
  }

  .follower-date {
    color: #6f6b86;
    font-size: 0.9rem;
  }

  .followers-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0.9rem 0.7rem 0.2rem;
    color: #9f9bb3;
    font-size: 0.8rem;
  }

  .followers-pagination {
    display: inline-flex;
    gap: 0.35rem;
    align-items: center;
  }

  .pager-btn {
    border: 1px solid #eceaf3;
    color: #7a768f;
    border-radius: 5px;
    padding: 0.2rem 0.45rem;
    font-size: 0.76rem;

    &.active {
      background: #0a2e57;
      color: #fff;
      border-color: #0a2e57;
    }
  }

  .best-ad-top {
    display: flex;
    align-items: flex-start;
    gap: 1.75rem;
    margin-bottom: 2.5rem;
  }

  .ad-stack {
    position: relative;
    width: 200px;
    height: 192px;
    flex-shrink: 0;
  }

  .stack-card {
    position: absolute;
    width: 148px;
    height: 192px;
    border-radius: 14px;
    top: 0;
    box-shadow: 0 6px 20px rgba(20, 20, 40, 0.18);
    transform-origin: center bottom;
  }

  .stack-1 {
    left: 0;
    background: radial-gradient(120% 80% at 100% 0%, #2a2a2a 0%, #0a0a0a 55%);
    z-index: 3;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
  }

  .stack-2 {
    left: 22px;
    z-index: 2;
    background: linear-gradient(160deg, #4a7ae8 0%, #2a4cb5 100%);
    transform: rotate(5deg);
  }

  .stack-3 {
    left: 42px;
    z-index: 1;
    background: linear-gradient(160deg, #c4d9a8 0%, #9aab7e 45%, #b8956e 100%);
    transform: rotate(9deg);
  }

  .ad-details {
    flex: 1;
    min-width: 0;
    padding-top: 0.25rem;
  }

  .running-ads-body .ad-detail-name {
    color: #3f3b57;
    font-weight: 700;
    font-size: 1.05rem;
    line-height: 1.25;
    margin-bottom: 0.5rem;
  }

  .running-ads-body .ad-detail-time {
    color: #7a7691;
    font-size: 0.8rem;
    margin-bottom: 0.65rem;
    line-height: 1.35;
  }

  .running-ads-body .ad-copy {
    color: #a8a4bc;
    font-size: 0.72rem;
    line-height: 1.5;
    margin-bottom: 1rem;
  }

  .ad-arrows {
    display: flex;
    gap: 1.1rem;
    align-items: center;
    margin-top: 0;
  }

  .ad-arrow-icon {
    color: #1a1a24;
    stroke-width: 2.25;
    cursor: default;
  }

  .ad-preview-image {
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: flex-end;
    width: 100%;
    height: 100%;
    padding: 0.75rem 0.5rem 1.25rem;
    text-align: center;
  }

  .ad-preview-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    border-radius: 8px;
  }

  .ad-preview-lens {
    position: absolute;
    top: 14%;
    right: 10%;
    width: 72px;
    height: 72px;
    border-radius: 50%;
    background: radial-gradient(circle at 35% 30%, #e8a060 0%, #b8622a 42%, #4a2412 100%);
    box-shadow:
      inset 0 2px 6px rgba(255, 255, 255, 0.35),
      0 4px 14px rgba(0, 0, 0, 0.55);
  }

  .ad-preview-title {
    position: relative;
    z-index: 1;
    color: #ff9a3c;
    font-size: 1.35rem;
    font-weight: 800;
    letter-spacing: 0.04em;
    line-height: 1.1;
  }

  .ad-preview-pro {
    position: relative;
    z-index: 1;
    color: #ff9a3c;
    font-size: 2rem;
    font-weight: 800;
    letter-spacing: 0.12em;
    line-height: 1;
    margin-top: 0.15rem;
  }

  .ad-metrics-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.125rem;
  }

  .ad-metric-card {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.9rem 1rem;
    border-radius: 12px;
    background: linear-gradient(135deg, #b8e4f5 0%, #7ec8ea 45%, #5fb8e0 100%);
    box-shadow:
      0 3px 12px rgba(70, 160, 200, 0.32),
      0 0 0 1px rgba(255, 255, 255, 0.25) inset;
    min-height: 70px;
  }

  .ad-metric-text {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    line-height: 1.15;
  }

  .ad-metric-value {
    color: #fff;
    font-size: 1.15rem;
    font-weight: 800;
    letter-spacing: 0.02em;
  }

  .ad-metric-label {
    color: rgba(255, 255, 255, 0.92);
    font-size: 0.68rem;
    font-weight: 600;
    margin-top: 0.12rem;
  }

  .ad-metric-icon {
    width: 26px;
    height: 26px;
    flex-shrink: 0;
    object-fit: contain;
    opacity: 0.98;
  }
}

.create-ad-modal,
.schedule-date-modal {
  .modal-dialog {
    max-width: 900px !important;
    width: calc(100% - 2rem);
    margin: 1.75rem auto !important;
  }

  .modal-content {
    border: 0;
    border-radius: 8px;
    overflow: hidden;
  }

  .modal-top {
    background: #f8f9fb;
    text-align: center;
    padding: 1.45rem 1.2rem 1rem;
    border-bottom: 1px solid #ececf2;
    position: relative;
  }

  .modal-top h2 {
    color: #101828;
    font-size: 2.25rem;
    margin-bottom: 0.3rem;
    font-weight: 700;
  }

  .modal-top p {
    margin-bottom: 0;
    color: #6f6b86;
    font-size: 0.9rem;
  }

  .modal-close-btn {
    position: absolute;
    top: 0.85rem;
    right: 0.9rem;
    width: 36px;
    height: 36px;
    border: 1px solid #e8e8ee;
    border-radius: 8px;
    background: #f2f3f6;
    color: #b1b1bc;
    line-height: 0;
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
  }

  .modal-body-wrap {
    padding: 1.25rem 1.75rem 1.75rem;
  }

  .section-heading {
    color: #1d2939;
    font-size: 2rem;
    margin: 0.1rem 0 0.75rem;
    border-bottom: 1px solid #d7ecec;
    padding-bottom: 0.35rem;
    font-weight: 700;
  }

  .field-label {
    margin-bottom: 0.3rem;
    color: #1d2939;
    font-size: 0.92rem;
    font-weight: 600;
    display: block;
  }

  .modal-field {
    margin-bottom: 0.8rem;
  }

  .modal-field .form-control,
  .modal-field .custom-select {
    height: 42px;
    border-color: #d8d6e0;
    font-size: 0.95rem;
    color: #5f5a73;
  }

  .field-error {
    color: #ea5455;
    font-size: 0.82rem;
    margin: 0.25rem 0 0.55rem;
    line-height: 1.3;
  }

  .modal-field.is-invalid .form-control,
  .modal-field.is-invalid .custom-select {
    border-color: #ea5455;
  }

  .field-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 0.9rem;
  }

  .upload-drop-zone {
    border: 2px dashed #b8bcc8;
    border-radius: 2px;
    min-height: 295px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin-bottom: 1rem;
    text-align: center;
  }

  .upload-drop-zone h4 {
    color: #111827;
    font-size: 2.35rem;
    font-weight: 500;
    margin-bottom: 0.9rem;
  }

  .upload-drop-zone h4 span {
    color: #0f8093;
  }

  .upload-drop-zone p {
    color: #7a758f;
    font-size: 1.25rem;
    margin-bottom: 0;
  }

  .call-action-row {
    border-bottom: 1px solid #ececf2;
    padding: 0.5rem 0 0.85rem;
    margin-bottom: 0.4rem;
    display: grid;
    grid-template-columns: 220px 1fr;
    align-items: center;
    gap: 1.1rem;
  }

  .call-action-row label {
    margin: 0;
    color: #111827;
    font-size: 0.95rem;
    font-weight: 500;
  }

  .submit-wrap {
    display: flex;
    justify-content: center;
    margin-top: 1.35rem;
    text-align: center;
  }

  .schedule-submit-wrap {
    margin-top: 3.4rem;
  }

  .submit-btn {
    background: #011425 !important;
    border-color: #011425 !important;
    color: #fff !important;
    min-width: 220px;
    padding: 0.62rem 1rem;
    font-size: 1.35rem;
    font-weight: 600;
    border-radius: 12px;
  }
}

.schedule-date-modal .schedule-highlight {
  border-bottom: 1px solid #bfe7ea;
  color: #101828;
  font-size: 2.45rem;
  font-weight: 600;
  padding-bottom: 0.45rem;
  margin-bottom: 1.15rem;
}

.schedule-date-modal .time-date-field {
  position: relative;
}

.schedule-date-modal .time-date-field label {
  margin-bottom: 0.35rem;
  color: #101828;
  font-size: 0.95rem;
  font-weight: 500;
  display: block;
}

.schedule-date-modal .field-icon {
  position: absolute;
  right: 12px;
  bottom: 11px;
  color: #c5c2d0;
  pointer-events: none;
}

.schedule-date-modal .native-picker-field .field-icon {
  display: none;
}

.schedule-date-modal .time-date-field.is-invalid .form-control,
.schedule-date-modal .time-date-field .form-control.is-invalid {
  border-color: #ea5455;
}

.schedule-date-modal .field-error {
  color: #ea5455;
  font-size: 0.82rem;
  margin: 0.25rem 0 0;
  line-height: 1.3;
}
</style>
